import "../../css/Containers/ContainerStyles.css";
import React, { CSSProperties } from "react";
import { ThemeStyle } from "../../hooks/useTheme";

type StandardContainerProps = {
  headerComp: React.ReactNode;
  divider?: boolean;
  valueComp?: React.ReactNode;
  theme: ThemeStyle;
  containerStyles?: CSSProperties;
};

const StandardContainer = (props: StandardContainerProps) => {
  const { headerComp, divider, valueComp, theme, containerStyles } = props;

  return (
    <div
      className="StandardContainer"
      style={{ ...theme.SecondaryBG, ...containerStyles }}
    >
      <div className="HeaderStandardContainer" style={theme.PrimaryText}>
        {headerComp}
      </div>
      {divider ? <hr style={theme.DividerColor} /> : null}
      <div className="ValueStandardContainer">{valueComp}</div>
    </div>
  );
};

export default StandardContainer;
